import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from '../../@common/configuration/app-config.service';

export interface MetaData {
    title: string;
    description: string | undefined;
    image: string | undefined;
    index: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class MetaService {
    private title = inject(Title);
    private meta = inject(Meta);
    private activatedRoute = inject(ActivatedRoute);
    private appConfig = inject(AppConfig);

    public set({ title, description, image, index }: MetaData) {
        this.title.setTitle(title || 'Videolectures');
        this.meta.updateTag({ property: 'og:title', content: title });
        this.meta.updateTag({ name: 'twitter:title', content: title });

        if (description) {
            this.meta.updateTag({ name: 'description', content: description });
            this.meta.updateTag({ property: 'og:description', content: description });
            this.meta.updateTag({ name: 'twitter:description', content: description });
        }

        const imageUrl = image || `${ this.appConfig.baseUrl }/assets/logo_big.png`;
        this.meta.updateTag({ property: 'og:image', content: imageUrl });
        this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

        this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
        const url = this.appConfig.baseUrl + (this.activatedRoute.snapshot as any)['_routerState'].url;
        this.meta.updateTag({ property: 'og:url', content: url });
        this.meta.updateTag({ property: 'og:type', content: 'website' });
        this.meta.updateTag({
            name: 'robots',
            content: (index && this.appConfig.isProduction) ? 'index,follow' : 'noindex,nofollow'
        });
    }
}
